<template>
<standard-map v-model="map" :value="mapCenter" :zoom="mapZoom" @initialized="onMapLoad" height="100%"></standard-map>
</template>

<script>
import StandardMap from "../StandardMap";

export default {
  name: "ImmoExposeMap",

  components: {
    StandardMap
  },

  data() {
    return {
      map: null
    }
  },

  computed: {
    mapCenter() {
      return this.$root.mapCenter;
    },

    mapZoom() {
      return this.$root.mapZoom;
    }
  },

  methods: {
    onMapLoad(o) {
      this.$root.mapMarkers.forEach((elm) => {
        o.L.marker({
          lat: elm.lat,
          lng: elm.lng
        }).addTo(o.map)
        .bindPopup(elm.html, {keepInView: true, minWidth: 260})
        .on("mouseover", function() {
          this.openPopup();
        })
        .on('click', function() {
          const targetElm = document.querySelector(".member-category li > button[data-filter = '" + elm.slug + "']");
          if (targetElm) {
            targetElm.scrollIntoView();
            targetElm.click();
          }
        })
      });

      this.map = this.mapCenter;
      o.L.control.zoom({
        position: 'bottomleft'
      }).addTo(o.map);
      o.map.zoomControl.remove();
      o.map.scrollWheelZoom.disable();
    }
  }
}
</script>
